var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 88,
    viewBox: "0 0 287 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.98 0H286.58V9.99H251.21L236 25.2V11.16L246.98 0ZM236 31.14L247.88 19.26V25.11H286.58V29.34L274.97 40.86V35.1H236V31.14ZM271.46 50.04L286.58 35.01V49.05L275.69 60.03H236V50.04H271.46Z",
    fill: "url(#paint0_linear_455_592)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.1 49.95L227.13 35.01V49.05L216.15 59.94H187.8L177 49.05V35.01L191.85 49.95H212.1Z",
    fill: "url(#paint1_linear_455_592)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.52 0H168.13V28.98L137.26 60.03H129.07L118 49.05V35.01L133.39 50.22L156.52 27V0Z",
    fill: "url(#paint2_linear_455_592)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9188 0H98.1788L109.249 10.98V29.34L97.6388 40.86V13.86L94.1288 10.26H73.9688L59.0288 25.2V10.98L69.9188 0ZM59.0288 31.14L70.6388 19.62V46.53L74.0588 50.04H94.3088L109.249 35.37V49.05L98.2688 60.03H69.8288L59.0288 49.05V31.14Z",
    fill: "url(#paint3_linear_455_592)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7 0L50.31 0.270002V29.52L38.7 41.22V33.48L15.21 10.17L0 25.38V10.98L10.8 0H19.62L38.7 18.9V0ZM0 31.14L11.61 19.53V60.03H0V31.14Z",
    fill: "url(#paint4_linear_455_592)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207.307 84.03H206.332V75.5611L207.307 75.3755V79.4939C207.666 78.6239 208.537 77.9394 209.743 77.9394C211.599 77.9394 212.725 79.2967 212.725 81.0485C212.725 82.8003 211.599 84.1692 209.743 84.1692C208.525 84.1692 207.678 83.4732 207.307 82.6031V84.03ZM207.307 80.0508V82.0578C207.852 82.8815 208.606 83.3456 209.534 83.3456C211.008 83.3456 211.75 82.2666 211.75 81.0485C211.75 79.842 211.008 78.7631 209.523 78.7631C208.606 78.7631 207.852 79.2271 207.307 80.0508ZM215.811 86.1183C215.451 86.1183 215.08 86.037 214.825 85.9094L214.697 85.0277C214.987 85.1786 215.335 85.2482 215.66 85.2482C216.333 85.2482 216.588 84.8885 216.913 84.0764L217.017 83.798L214.488 78.0786H215.533L217.551 82.7307L219.535 78.0786H220.556L217.795 84.4941C217.308 85.631 216.878 86.1183 215.811 86.1183ZM230.339 80.8049L234.341 84.03H232.299L227.914 80.4568V84.03H226.522V75.9092H231.221C233.088 75.9092 234.167 76.8953 234.167 78.3686C234.167 79.8072 233.088 80.8049 231.255 80.8049H230.339ZM232.775 78.4266C232.775 77.6261 232.102 77.1389 231.058 77.1389H227.914V79.7376H231.058C232.079 79.7376 232.775 79.2503 232.775 78.4266ZM243.576 84.03H236.848V75.9092H243.507V77.1621H238.24V79.2387H243.449V80.4917H238.24V82.7771H243.576V84.03ZM247.704 84.03H246.312V75.9092H252.797V77.1621H247.704V79.4127H252.797V80.6541H247.704V84.03ZM259.337 84.1924C256.623 84.1924 254.999 82.255 254.999 79.9696C254.999 77.6842 256.623 75.7468 259.337 75.7468C262.052 75.7468 263.676 77.6842 263.676 79.9696C263.676 82.255 262.052 84.1924 259.337 84.1924ZM259.337 82.9395C261.263 82.9395 262.273 81.5242 262.273 79.9696C262.273 78.415 261.263 76.9997 259.337 76.9997C257.412 76.9997 256.402 78.415 256.402 79.9696C256.402 81.5242 257.412 82.9395 259.337 82.9395ZM270.089 80.8049L274.091 84.03H272.05L267.664 80.4568V84.03H266.272V75.9092H270.971C272.838 75.9092 273.917 76.8953 273.917 78.3686C273.917 79.8072 272.838 80.8049 271.005 80.8049H270.089ZM272.525 78.4266C272.525 77.6261 271.852 77.1389 270.808 77.1389H267.664V79.7376H270.808C271.829 79.7376 272.525 79.2503 272.525 78.4266ZM281.412 81.6054L284.452 75.9092H286.122V84.03H284.765V77.835L281.459 84.03H281.273L277.955 77.835V84.03H276.598V75.9092H278.349L281.412 81.6054Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_592",
    x1: 234.765,
    y1: 3,
    x2: 289.716,
    y2: 4.73418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_455_592",
    x1: 175.776,
    y1: 36.2559,
    x2: 229.984,
    y2: 40.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_455_592",
    x1: 116.776,
    y1: 3,
    x2: 171.239,
    y2: 4.70349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_455_592",
    x1: 57.8021,
    y1: 3,
    x2: 112.363,
    y2: 4.70961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_455_592",
    x1: -1.22887,
    y1: 3,
    x2: 53.4294,
    y2: 4.71574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovusLogo);
export default __webpack_public_path__ + "static/media/novus-logo.c96ff180c0430bcf80752cca3f529f8f.svg";
export { ForwardRef as ReactComponent };